import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/components/coming-soon-page';

export const Route = createFileRoute('/_authed/dashboard/retention')({
  component: () => (
    <ComingSoonPage
      title="Retention"
      description="Who is slipping away, and who is due a rebooking prompt. Coming soon."
    />
  ),
});
